import { render } from "./ResolutionFilter.vue?vue&type=template&id=196b6e39"
import script from "./ResolutionFilter.vue?vue&type=script&lang=js"
export * from "./ResolutionFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__